import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayCircleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.0578 11.0756L11.5056 8.70667C11.3381 8.59492 11.1434 8.53079 10.9422 8.52112C10.7411 8.51145 10.5412 8.55661 10.3637 8.65178C10.1863 8.74694 10.038 8.88854 9.93483 9.06142C9.83163 9.23431 9.77734 9.43199 9.77777 9.63334V14.37C9.77774 14.5712 9.83232 14.7686 9.93569 14.9411C10.0391 15.1137 10.1873 15.255 10.3647 15.3499C10.5421 15.4448 10.7419 15.4897 10.9428 15.48C11.1437 15.4702 11.3382 15.4061 11.5056 15.2944L15.0578 12.9256C15.2099 12.8241 15.3347 12.6866 15.421 12.5254C15.5073 12.3641 15.5525 12.184 15.5525 12.0011C15.5525 11.8182 15.5073 11.6381 15.421 11.4769C15.3347 11.3156 15.2099 11.177 15.0578 11.0756Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7363 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7363 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7363 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

PlayCircleIcon.displayName = 'PlayCircleIcon';
